import axios from "axios";

const http = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
  withCredentials: true,
});

const EVENT_FIELDS = `id seriesId title description category startsAt endsAt timeZone venueName city latitude longitude destinationId organizer sourceUrl registrationUrl imageUrl status`;

const GET_EVENTS = `query RideEvents($from: String!, $to: String!, $limit: Int) {
  rideEvents(from: $from, to: $to, limit: $limit) { ${EVENT_FIELDS} }
}`;

const GET_DESTINATION_EVENTS = `query RideEventsByDestination($destinationId: ID!, $limit: Int) {
  rideEventsByDestination(destinationId: $destinationId, limit: $limit) { ${EVENT_FIELDS} }
}`;

const GET_SERIES = `query RideEventSeries($id: ID!) {
  rideEventSeries(id: $id) {
    id title description organizer sourceUrl
    events { ${EVENT_FIELDS} }
  }
}`;

async function request(query, variables, signal) {
  const { data } = await http.post("", { query, variables }, { signal });
  if (data.errors?.length) throw new Error(data.errors[0].message || "Events could not be loaded");
  if (!data.data) throw new Error("Empty events response");
  return data.data;
}

/** Read-only public API. Admin operations must use the authorized admin client. */
export async function getUpcomingRideEvents({ from = new Date(), days = 90, limit = 100, signal } = {}) {
  const start = new Date(from);
  if (!Number.isFinite(start.getTime()) || !Number.isInteger(days) || days < 1 || days > 366) {
    throw new Error("Invalid events date range");
  }
  const end = new Date(start.getTime() + days * 86400000);
  const data = await request(GET_EVENTS, { from: start.toISOString(), to: end.toISOString(), limit }, signal);
  return data.rideEvents;
}

/** destinationId is the public catalogue slug used by park detail routes. */
export async function getDestinationRideEvents(destinationId, { limit = 10, signal } = {}) {
  if (typeof destinationId !== "string" || !destinationId.trim()) throw new Error("Destination ID is required");
  if (!Number.isInteger(limit) || limit < 1 || limit > 50) throw new Error("Invalid event limit");
  const data = await request(GET_DESTINATION_EVENTS, { destinationId: destinationId.trim(), limit }, signal);
  return data.rideEventsByDestination;
}

export async function getRideEventSeries(id, { signal } = {}) {
  if (!id) return null;
  const data = await request(GET_SERIES, { id }, signal);
  return data.rideEventSeries;
}
